module.exports = __webpack_public_path__ + "img/map.db30b212.png";